import { cn } from "@utils/tw"
import { defineBlock, EditableText, InnerBlocks, useInnerBlocks } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Features Stack Inner",
}

export default defineBlock("section/features-stack-inner", (props) => {
  const inner = useInnerBlocks()
  const total = inner.length

  return (
    <div
      className={cn(
        "features-stack-inner w-full max-w-blogPostVideoW mx-auto",
        !env.admin && "grid grid-cols-1 gap-4",
        !env.admin && (total === 2 || total === 4) && "md:grid-cols-2",
        !env.admin && total >= 3 && total !== 4 && "md:grid-cols-3",
        (total === 2 || total === 4) &&
          "[&_.first]:border-b [&_.first]:border-b-grey-0 [&_.first]:md:border-b-0 [&_.first]:md:border-r [&_.first]:md:border-grey-0",
        total >= 3 &&
          total !== 4 &&
          "[&_.first-two]:border-b [&_.first-two]:border-b-grey-0 [&_.first-two]:md:border-b-0 [&_.first-two]:md:border-r [&_.first-two]:md:border-grey-0",
      )}
    >
      <InnerBlocks
        allowedBlocks={["section/features-stack-inner-card"]}
        adminClassName={cn(
          "grid grid-cols-1 gap-4",
          (total === 2 || total === 4) && "md:grid-cols-2",
          total >= 3 && total !== 4 && "md:grid-cols-3",
        )}
        template={[
          ["section/features-stack-inner-card", {}],
          ["section/features-stack-inner-card", {}],
          ["section/features-stack-inner-card", {}],
        ]}
      />
    </div>
  )
})
